import {
  clearSessionStorage,
  getSessionStorage,
  setSessionStorage,
  sessionStorageDictionary,
} from '../../../sessionStorage';
import {PortalConfig} from '../ApiService/types/endpoints';

type StoredPortalConfig = {
  config: PortalConfig;
};

/**
 * ConfigManager
 * Allow to get, set and clear the configuration.
 * Persist the configuration in the session storage.
 */
class ConfigManager {
  private config: PortalConfig | null = null;

  /**
   * Constructor
   * Load the configuration from the session storage.
   * If the configuration is not found, set it to null.
   */
  constructor() {
    try {
      const storedPortalConfig: StoredPortalConfig = getSessionStorage(
        sessionStorageDictionary.PORTAL_CONFIG,
      );
      this.config = storedPortalConfig.config;
    } catch (e) {
      // Reset the configuration state
      this.clear();
    }
  }

  /**
   * Get the configuration.
   */
  getConfig(): PortalConfig | null {
    return this.config || null;
  }

  /**
   * Set the configuration.
   */
  setConfig(config: PortalConfig) {
    this.config = config;

    const storedConfig: StoredPortalConfig = {
      config: this.config,
    };

    setSessionStorage(sessionStorageDictionary.PORTAL_CONFIG, storedConfig);
  }

  /**
   * Clear the configuration.
   */
  clear() {
    this.config = null;
    clearSessionStorage(sessionStorageDictionary.PORTAL_CONFIG);
  }
}

const configManager = new ConfigManager();

export default configManager;
